<template>
  <q-dialog
    :visible="isVisible"
    title="编辑"
    width="50%"
    :innerScroll="false"
    :loading="loadingBtn"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" size="mini" v-loading="loading">
      <el-row>
        <el-col :span="24">
          <el-form-item label="产品编码:">{{ form.productCode }}</el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="产品名称:">{{ form.productName }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="A类价系数:" prop="dailyRetailPrice">
            <el-select v-model="form.dailyRetailPrice" filterable placeholder="请选择">
              <el-option :label="item.optionValue" :value="item.optionValue" v-for="item in optsList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调整原因:" prop="reason">
            <el-input type="textarea" :rows="2" v-model="form.reason"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'PriceUpholdEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      optsList: [],
      form: {},
      rules: {},
    };
  },
  created() {
    this.getOptions();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    getOptions() {
      this.loading = true;
      let data = {
        pageNum: 1,
        pageSize: 1000,
        filterData: {
          optionType: '30',
          tag: 3,
        },
      };
      this.$q.goods
        .listPage({ data })
        .then((res) => {
          this.optsList = res.data.records || [];
          // 设置表单数据
          this.form = {
            productCode: this.row.productCode,
            productName: this.row.productName,
            dailyRetailPrice: this.row.dailyRetailPrice,
            reason: this.row.reason,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.loadingBtn = true;
        // 判断是新增还是编辑
        const hasId = !!this.row.id;
        const data = { ...this.form };
        if (hasId) {
          data.id = this.row.id;
        }
        const api = hasId
          ? this.$q.product.productPriceCoefficientUpdateById
          : this.$q.product.productPriceCoefficientInsertData;
        api({ data })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功');
              this.isVisible = false;
              this.$emit('success');
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
</style>
